export default __webpack_public_path__ + "static/media/jt2.194c5883.jpg";